<template>
	<div id="company_list mt10 print-display">
		<div class="panel panel-default m0">
			<div class="panel-heading" v-if="add=='yes'">
	  			<div class="row">
					<div class="col-xs-6 ptb4" v-if="title!=null">
			            <span class="cae bk bk-green">{{title}}</span>
			        </div>
					<div class="col-xs-6" :class="{'col-xs-offset-6': title==null}">
						<div class="btn-group pull-right pr15" @click="doAdd" v-if="ex==null">
							<a v-link="{path:infourl}" class="btn btn-block btn-sm btn-primary pull-right"> 
								<i class="glyphicon glyphicon-plus"></i>
								{{addtxt}}
							</a>
						</div>
						<div class="btn-group pull-right pr15" @click="doExport" v-if="ex!=null">
							<a href="javascript:;" class="btn btn-block btn-sm btn-primary pull-right"> 
								{{addtxt}}
							</a>
						</div>
					</div>		
				</div>	
	  		</div>
			<div class="panel-body">
			    <slot></slot>
			   	<ly-loading v-if="isLoading"></ly-loading>
				<div class="nodata" v-if="!isLoading && dataLength < 1"></div>
		    </div>
	    </div>
		<ly-page :total="total" v-if="nopage==undefined"></ly-page>
	</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	var Comm = require('../utils/Common.js');
	/**
	 * 验证时间组件，开始结束日期需同时填写
	 * @param  {[type]} comp [description]
	 * @return {[type]}      [description]
	 */
	var timeValidate = function(comp) {
		// if(!comp.datetime.date_start && comp.datetime.date_end) {
		// 	Comm.tipDialog("请选择开始时间",1000,"error");
		// 	return false;
		// } else if(comp.datetime.date_start && !comp.datetime.date_end){
		// 	Comm.tipDialog("请选择结束时间",1000,"error");
		// 	return false;
		// }
		return true;
	};
	/*由于VM 里的submit和search方法是一样，在这里统一*/
	var submitFun = function(comp) {
		var Page = comp.$children[0];
		Page.page = 1;			
		if(comp.datetime && timeValidate(comp)) {//结束时间和开始时间验证是否填写
			Query(comp,Page.page,comp.perpage,comp.formdata,comp.datetime,comp.id);
		} else if(!comp.datetime) {
			Query(comp,Page.page,comp.perpage,comp.formdata,comp.id);
		}
	}
	/**
	 * [paramsQuery description]
	 * @param  {[type]} arr [description]
	 * @return {[type]}     [description]
	 */
	var paramsQuery = function(arr) {
		Comp.isLoading = true;//标识加载中...
		Comp.$dispatch('datalist', []);//加载前设置为空数据
		// var arr = arr || [];
		Http[Comp.url].query({
			// key: [arr['id']],
			key: [arr],
			succ : function(rs){
				if(rs.total != undefined){
					Comp.total = rs.total;
					Comp.dataLength = rs.data.length;//获得数据的长度
					Comp.$dispatch('datalist', rs.data);
				}else{
					Comp.total = 0;
					Comp.dataLength = rs.length;//获得数据的长度
					Comp.$dispatch('datalist', rs);				
				}				
				Comp.isLoading = false;//加载完毕
			},
			err : function(){
				Comp.isLoading = false;//加载完毕
				Comp.dataLength = 0;//获得数据的长度
			}
		});
	}
	/**
	* 查询操作的处理
	* @param Component 组件对象
	* @param url 请求的地址
	* @param page 页数
	* @param perpage 每页的条数
	* @param formdata 搜索框传的数据对象
	* @param datetime  时间组件里传的数据对象
	*/
	var Query = function(Comp,page,perpage,formdata,datetime,arr){
		Comp.isLoading = true;//标识加载中...
		Comp.$dispatch('datalist', []);//加载前设置为空数据
		var data = {};
		var datetime = datetime || {};
		var formdata = formdata || {};
		// var arr = arr || [];
		if(datetime) {
			Comm.propertyToObj(data,datetime);//将datetime的属性赋给data
		}
		if(formdata) {
			Comm.propertyToObj(data,formdata);//将formdata的属性赋给data
		}
		data.page = page;
		data.perpage = perpage;
		Http[Comp.url].query({
			// key: [arr['id']],
			key: [arr],
			data: data,
			succ : function(rs){
				if(rs.total != undefined){
					Comp.total = rs.total;
					Comp.dataLength = rs.data.length;//获得数据的长度
					Comp.$dispatch('datalist', rs.data);
				}else{
					Comp.total = 0;					
					if(Comp.outdata != undefined) {						
						Comp.dataLength = rs.data.length;//获得数据的长度	
						Comp.$dispatch('datalist', rs.data);				
					} else {
						Comp.dataLength = rs.length;//获得数据的长度	
						Comp.$dispatch('datalist', rs);			
					}				
				}	
				Comp.$dispatch('outData',rs);//获取营业统计与页数同层的总额数据
				Comp.isLoading = false;//加载完毕
			},
			err: function(msg) {
				Comp.isLoading = false;//加载完毕
				Comp.dataLength = 0;//获得数据的长度
			}
		});
	};
	/**
	 * 无分页时
	 */
	var noPageQuery = function (Comp) {
		Comp.isLoading = true;//标识加载中...
		Comp.$dispatch('datalist', []);//加载前设置为空数据
		Http[Comp.url].query({
			succ : function(rs){
				Comp.$dispatch('datalist', rs);	
				Comp.dataLength = rs.length;//获得数据的长度				
				Comp.isLoading = false;//加载完毕
			},
			err: function(msg) {
				Comp.isLoading = false;//加载完毕
				Comp.dataLength = 0;//获得数据的长度
			}
		});
	};
	/**
	* 组件对象
	* @param multivue  表示有几个vue对象。 当列表里面有多个vue对象时，page应在最后一个vue的$children里
	* @param outdata 后台返会数据最外层的额外数据
	*/
	var Component = {
		props : ['add','title','addtxt','infourl','url','formdata','datetime','id','ex','multivue','nopage','outdata'],
		data : function () {
			return {
				total : 1,
				isLoading : false ,//标识是否在加载商品的数据
				dataLength : 0 ,//数据的长度
				perpage: 20,
			}
		},
		components :  {
			'ly-page' : require('./Page.vue'),
			'ly-loading' : require('./Loading.vue'),
		},
		ready : function () {
			var Page = {};			
			if(this.multivue == undefined) {
				Page = this.$children[0];
			} else {
				Page = this.$children[parseInt(this.multivue)-1];
			}
			if(this.nopage == undefined) {//需要分页时
				var self = this;
				if(this.id == 0) { 
					/**
					 * 监听id变化
					 */
					this.$watch("id",function(v) {
						if(v != 0) {//过滤id为0的内容
							Query(self,Page.page,Page.perpage,self.formdata,self.datetime,self.id);
						}
					});	
				} else {
					Query(this,Page.page,Page.perpage,this.formdata,this.datetime,this.id);
				}				
			} else {//无分页时
				noPageQuery(this);
			}			
		},
		methods: { 
			/**
			* 新增
			*/
			doAdd: function(){
				this.$dispatch('doAdd');//分发传递
			},
			doExport: function() {
				this.$dispatch('doExport');//分发传递
			}
		},
		events : {
			/**
			* 分页操作的监听
			*/
			paging : function(page,perpage){
				var formdata = this.formdata;
				var timedata = this.datetime;
				this.perpage = perpage;
				Query(this,page,perpage,formdata,timedata,this.id);
			},
			submit: function() {
				submitFun(this);//调用上面定义的方法。验证时间后搜索
			},
			search: function() {			
				submitFun(this);//调用上面定义的方法。验证时间后搜索
			},
			search_doSearch: function() {
				submitFun(this);//调用上面定义的方法。验证时间后搜索
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** Datalist.vue?4f2f13c4
 **/